import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: `ezugi/game_list`,
  converter,
  getHeaders: () => ({
    headers: {
      'x-partner-authorization': parseCookies(),
      'x-partner-name': projectName,
    },
  }),
  sessionUrlData: {
    url: 'ezugi/frame_url',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      openTable: params.id,
      language: shortLanguages[params.lang as keyof typeof shortLanguages],
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
